import { useAppSelector } from "./useAppSelector";

/**
 * Centralize toàn bộ check access cho registration flow.
 * Pages không cần tự useEffect navigate — đọc trạng thái rồi render conditional,
 * route-level guards (ProtectedRoute, RequireAccess) đảm nhận redirect.
 *
 * <c>canPreview</c>: SV được phép xem trước /classes khi cổng chưa mở.
 *   Bật bởi appsettings <c>Registration:AllowPreviewBeforeOpen=true</c>. Chỉ áp dụng
 *   khi chưa hasAccess, chưa inQueue và Date.now() &lt; openAt (tức cổng thật sự chưa mở).
 *   Sau openAt / khi admin mở cổng (SignalR PeriodOpened → re-fetch status) → canPreview
 *   tự false, RequireAccess sẽ điều hướng về LandingPage.
 */
export const useAccessControl = () => {
    const { hasAccess, inQueue, periodClosed, openAt, allowPreviewBeforeOpen } =
        useAppSelector(s => s.queue);
    const { user, access_token } = useAppSelector(s => s.auth);

    const openTs = openAt ? new Date(openAt).getTime() : null;
    const beforeOpen = openTs != null && !Number.isNaN(openTs) && Date.now() < openTs;
    const canPreview = !!allowPreviewBeforeOpen && beforeOpen && !hasAccess && !inQueue && !periodClosed;

    return {
        isAuthenticated: !!access_token && !!user,
        hasAccess,
        inQueue,
        periodClosed,
        canRegister: hasAccess && !periodClosed,
        canPreview,
    };
};
